import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ClientsService } from '@app/shared/services/clients.service';
import { SupplymaterialService } from '@app/shared/services/supplymaterial.service';

interface Material {
  name: string;
  submaterials: string[];
  descriptions: string[];
}

interface Subgroup {
  name: string;
  materials: Material[];
}

interface Group {
  name: string;
  subgroups: Subgroup[];
}

@Component({
  selector: 'app-supply-materials',
  templateUrl: './supply-materials.component.html',
  styleUrls: ['./supply-materials.component.css']
})
export class SupplyMaterialsComponent implements OnInit{
 
  
  isPopupVisible: boolean = false;

  

  constructor() {
  
  }
  ngOnInit(): void {
 
  
  }
  

  openPopup() {
    this.isPopupVisible = true;
  }

  closePopup() {
    this.isPopupVisible = false;
  }
  
}
